/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { EntitlementIndexPathParams, EntitlementIndexResponse } from '../types/EntitlementIndex'

/**
 * GET /:organisation/entitlements
 * @see backend/nexus/modules/Billing/Http/Controllers/EntitlementController.php EntitlementController::index
 */
export async function entitlementIndex(
	organisation: EntitlementIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<EntitlementIndexResponse>> {
	return axiosInstance.get(`/${organisation}/entitlements`, config)
}
